const ACCOUNT_TYPE_BANK_PRODUCT_TYPE = {
    usersAccount: 'USERS_ACCOUNT',
    clientsAccount: 'CLIENTS_ACCOUNT',
    corporateAccount: 'CORPORATE_ACCOUNT'
}

export {
    ACCOUNT_TYPE_BANK_PRODUCT_TYPE
}
